import { useNavigate } from "react-router-dom";
import styles from "./ClientTable.module.scss";

function ClientTable({ clients }) {
  const navigate = useNavigate();

  const handleViewClient = (clientId) => {
    navigate(`/admin/clients/${clientId}`);
  };

  return (
    <table className={styles.tableContainer}>
      <thead>
        <tr>
          <th>Nom</th>
          <th>Prénom</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Adresse</th>
          <th>Date d'inscription</th>
        </tr>
      </thead>
      <tbody>
        {clients &&
          clients.map((client) => (
            <tr
              key={client.id}
              className={styles.clientRow}
              onClick={() => handleViewClient(client.id)}
            >
              <td>{client.last_name}</td>
              <td>{client.first_name}</td>
              <td>{client.email}</td>
              <td>{client.phone_number || "-"}</td>
              <td>{client.address || "-"}</td>
              <td>
                {new Date(client.created_at).toLocaleDateString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default ClientTable;
